import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { useGetFetchNew } from "../../../data/Queries";
import {
  academy_course_categories,
  add_academy_course_category,
  delete_academy_course_categories,
  update_academy_course_category,
} from "../../../data/ApiEndpoints";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { formatDate } from "../../../utils/utilityfunc";
// import "./category.css";
import { DeleteIcon, EditIcon } from "../../../images/icons/website-icons";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";

const categorySchema = Yup.object().shape({
  name: Yup.string().required("Category name is required"),
});

const ManageCategory = ({
  closeModal,
  token,
  initialValues,
  //   getCategoryData,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [isEdit, setIsEdit] = useState(false);

  const {
    data: categoryData,
    isLoading: categoryLoading,
    refetch,
  } = useGetFetchNew({
    token,
    key: "academy_course_categories",
    url: `${academy_course_categories}`,
    filters: {
      limit: pageLimit,
      page: isPage + 1,
    },
  });

  // console.log("isEdit===>", isEdit);

  const formik = useFormik({
    initialValues: initialValues || {
      name: "",
      uid: "",
    },
    validationSchema: categorySchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const method = isEdit ? "PUT" : "POST";
        const endpoint = isEdit
          ? update_academy_course_category
          : add_academy_course_category;

        const payload = isEdit
          ? {
              name: values.name,
              uid: values.uid || initialValues?.uid,
            }
          : {
              name: values.name,
            };

        const result = await dispatch(
          commonPostPutApi({ method, endpoint, payload, token })
        );

        if (result?.payload?.status) {
          toast.success(result?.payload?.message || "Success!");
          formik.resetForm();
          //   getCategoryData();
          refetch();
          if (isEdit) {
            setIsEdit(false);
          }
        } else {
          const errorMessage =
            result?.error?.message || result?.payload?.message;
          toast.error(errorMessage || "Something Went Wrong!");
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("Something went wrong!");
      } finally {
        setIsLoading(false);
      }
    },
  });

  const handleEdit = (row) => {
    setIsEdit(true);
    formik.setValues({
      name: row.name,
      uid: row.uid || row._id,
    });
  };
  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: token,
              endpoint: delete_academy_course_categories,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            // getCategoryData();
            refetch();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  const handleSwitchToAdd = () => {
    setIsEdit(false);
    formik.resetForm();
  };

  const tbColumns = [
    {
      dataField: "name",
      text: "Name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">{formatDate(row?.date_added || "NA")}</span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <p className="tb-data flexCenter">
            <span
              className={
                row?.status === "active" ? "greenColorBg" : "redColorBg"
              }
            >
              {row?.status || "NA"}
            </span>
          </p>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (cell, row) => {
        return (
          <div className="actionButtonContainer">
            <button
              className="actionBtn icon edit"
              onClick={() => handleEdit(row)}
              disabled={isLoading}
            >
              <EditIcon />
            </button>

            <button
              className="actionBtn icon delete"
              onClick={() => {
                const uidFilter = {
                  uid: row?.uid || "",
                };
                handleDelete(uidFilter);
              }}
            >
              {/* {loading ? <Loader /> : <DeleteIcon />} */}
              <DeleteIcon />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns title="Manage Categories" onClose={closeModal} />

      <form
        className="management-form-container"
        onSubmit={formik.handleSubmit}
      >
        <div className="form-grid form-grid-2">
          <div className="management-form-group">
            <input
              type="text"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter Category Name"
              className={`management-form-input ${
                formik.touched.name && formik.errors.name ? "error" : ""
              }`}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="management-form-error">{formik.errors.name}</div>
            )}
          </div>

          <div className="d-flex gap-3 ">
            <button
              type="submit"
              className="management-form-btn-danger"
              disabled={isLoading}
            >
              {isLoading
                ? "Processing..."
                : isEdit
                ? "Update Category"
                : "Add Category"}
            </button>
            {isEdit && (
              <button
                type="button"
                className="management-form-btn-outline-primary"
                onClick={handleSwitchToAdd}
                disabled={isLoading}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
      </form>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt-3">
        <PaymentLinkTable
          tableData={categoryData?.data}
          tableColumns={tbColumns}
          tablePagination={categoryData?.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          setPageLimit={setPageLimit}
          pageLimit={pageLimit}
          isLoading={categoryLoading}
        />
      </div>
    </div>
  );
};

export default ManageCategory;
